"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var isEvent = function isEvent(candidate) {
  return !!(candidate && candidate.stopPropagation && candidate.preventDefault);
};

var _default = isEvent;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/lib/events/isEvent.js
// module id = 164
// module chunks = 0